import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import ListClients from '../../components/Clients/ListClients';
import AdminLayout from "../../layouts/AdminLayout";

// (2026-05-15) Gestión de Terceros del emisor: reutiliza la Lista de
// Clientes en modo "terceros" (solo los terceros vinculados al cliente del
// usuario; sin filtros de tipo; crear/editar/eliminar solo operador_admin).
export default function ListTercerosPage() {
  const { user } = useContext(AuthContext);
  const nombreUsuario = user?.nombre || "Usuario";

  return (
    <AdminLayout nombreUsuario={nombreUsuario}>
      <div className="mt-8 px-4 md:px-8">
        <ListClients mode="terceros" />
      </div>
    </AdminLayout>
  );
}
